import React, { Component } from "react";
import Tippy from "@tippyjs/react";
import AngleInput from 'angle-input/react'
import 'tippy.js/dist/tippy.css';
import 'angle-input/angle-input.css';
import '../css/angle-input.css';
import Twemoji from 'react-twemoji';

class BoatControl extends Component {
    constructor(props) {
        super(props);
        this.desiredBearingInput = this.desiredBearingInput.bind(this);
        this.desiredBearingChange = this.desiredBearingChange.bind(this);
        this.state = {
            firstLoad: true
        }

    }

    render() {
        const boat = this.props.boatData;
        if (boat) {
            let windForce;

            if (boat.weather.wind.speed > 25) {
                windForce = 5;
            } else if (boat.weather.wind.speed > 18) {
                windForce = 4;
            } else if (boat.weather.wind.speed > 13) {
                windForce = 3;
            } else if (boat.weather.wind.speed > 6) {
                windForce = 2;
            } else if (boat.weather.wind.speed > 2) {
                windForce = 1;
            } else {
                windForce = 0;
            }

            let windDirection = boat.weather.wind.deg;
            if (windDirection > 180) windDirection -= 180;
            else windDirection += 180;

            const windDisplayStyle = {
                transform: 'rotate(' + (windDirection - 180) + 'deg)'
            };

            const windDisplayClass = 'animation-wind-' + windForce;

            const weatherSymbolUrl = 'https://openweathermap.org/img/wn/' + boat.weather.weather[0].icon + '@2x.png'
            const weatherDisplay = <img src={weatherSymbolUrl} class="weather-icon" alt={(boat.weather.weather[0].description.charAt(0).toUpperCase() + boat.weather.weather[0].description.slice(1))} />;


            const toolTipStyle = {
                fontSize: '0.8em'
            };
            const weatherName = boat.weather.weather[0].description.charAt(0).toUpperCase() + boat.weather.weather[0].description.slice(1);

            return (
                <div id="boat_control">

                    <span id='windspeed-display'>{(boat.weather.wind.speed.toFixed(1))}</span>
                    <Tippy content={(
                        <div>
                            <b>{weatherName}</b><br />
                            <span style={toolTipStyle} id="weatherTooltipEmoji">
                                <Twemoji>🌡   {((boat.weather.main.temp - 273.15).toFixed(2))} °C</Twemoji>
                                <Twemoji>🌀   {boat.weather.main.pressure} hPa</Twemoji>
                                <Twemoji>💧   {boat.weather.main.humidity} %</Twemoji>
                                <Twemoji>👁   {boat.weather.visibility} m</Twemoji>
                                <Twemoji>☁   {boat.weather.clouds.all} %</Twemoji>
                            </span>
                        </div>
                    )} allowHTML='true' theme='custom' placement='auto'>
                        <span id='weather-display'>{weatherDisplay}</span>
                    </Tippy>
                    {boat ?
                        <AngleInput
                            onChange={this.desiredBearingChange}
                            onInput={this.desiredBearingInput}
                            defaultValue={360 - boat.desiredBearing + 90}
                        /> : null}
                    <div id='wind-display' style={windDisplayStyle} className={windDisplayClass}></div>
                </div >
            );
        } else {
            return <div></div>
        }
    }

    desiredBearingChange(value) {
        this.props.desiredBearingChange(this.getCleanedAngle(value));
    }
    desiredBearingInput(value) {
        this.props.desiredBearingInput(value);
    }
    getCleanedAngle(angle) {
        let angleValue = angle - 90;
        if (angleValue < 0) {
            angleValue += 360;
        }
        return 360 - angleValue;
    }
}


export default BoatControl;
